import { RepeaterController } from "../classes/RepeaterController";
import { DOMFactoryController } from "../classes/DOMFactory";
import { GoogleAutocompleteService } from "../classes/GoogleAutocompleteService";
import { MultiLocationController } from "../classes/MultiLocationController";
import { InputValidatorController } from "../classes/InputValidator";

window.addEventListener("DOMContentLoaded", () => {
  const DOMFactory = new DOMFactoryController();
  const autocompleteService = new GoogleAutocompleteService();
  const repeaterController = new RepeaterController(
    DOMFactory,
    autocompleteService
  );
  const multiLocation = new MultiLocationController(repeaterController);
  const inputValidator = new InputValidatorController(DOMFactory);

  if (document.getElementById("job_location")) {
    const buttonContainer = document.querySelector<HTMLButtonElement>(
      ".js-jobtek-add-location"
    );
    const locations = buttonContainer?.dataset.locations
      ? JSON.parse(buttonContainer.dataset.locations)
      : [];
    console.log(buttonContainer?.dataset.locations);
    inputValidator.validate(
      document.getElementById("job_location") as HTMLInputElement
    );
    multiLocation.generateExistingItems(
      buttonContainer as HTMLButtonElement,
      locations
    );
  }

  if (document.getElementById("_job_location")) {
    const buttonContainer = document.querySelector<HTMLButtonElement>(
      ".js-jobtek-add-location"
    );
    const locations = buttonContainer?.dataset.locations
      ? JSON.parse(buttonContainer.dataset.locations)
      : [];
    console.log(buttonContainer?.dataset.locations);
    inputValidator.validate(
      document.getElementById("_job_location") as HTMLInputElement
    );
    multiLocation.generateExistingItems(
      buttonContainer as HTMLButtonElement,
      locations
    );
  }

  multiLocation.init();
});
